module.exports = __webpack_public_path__ + "img/home-page.8b238021.jpg";